export default __webpack_public_path__ + "static/media/miki-furue-mila-the-vegan.9467c6f1.png";